<script>
import CheckBox from "@/components/check-box";

import {
  required
} from "vuelidate/lib/validators";

export default {
  components: {
    CheckBox
  },
  props: {
    digitalDetail: {
      type: Object,
    },
    packageType: {
      type: String,
      default: ''
    }
  },
  mounted() {
    if (this.digitalDetail) {
      Object.assign(this.form, this.digitalDetail)
    } 
  },
  validations: {
    form: {
      digitalChannels: { required },
      impressions: { required },
      digitalPrice: { required }
    }
  },
  data() {
    return {
      submitted: false,
      form: {
        digitalChannels: [],
        impressions: '',
        digitalPrice: '',
      }
    }
  },
  methods: {
    submitDigitalModal(cancel) {
      this.submitted = true;

      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.$emit('submit', { data: this.form, cancel })
      }
    }
  }
}
</script>

<template>
  <b-modal id="digital-modal" centered size="lg">
    <template v-slot:modal-header="{ close }">
      <div class="text-center w-100 position-relative">
        <b-button size="sm" variant="link" @click="close()" class="position-absolute top-0 right-0">
          <i class="bx bx-x font-size-24 text-dark"></i>
        </b-button>
        <div class="text-center">
          <h4>Digital Channel</h4>
        </div>
      </div>
    </template>
    <div>
      <b-form-group>
        <label for="channels" class="card-title">Digital Channels</label>
        <p>Select channels for Digital Configuration</p>
        <div class="row" :class="{ 'is-invalid': submitted && $v.form.digitalChannels.$error }">
            <div class="col-12 col-md-6 col-lg-3">
              <check-box
                title="Display"
                icon="bx-fullscreen"
                text="Display Ads both On and Off Network"
                id="Display"
                name="Display"
                value="Display"
                v-model="form.digitalChannels"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <check-box
                title="Social"
                icon="bx-share"
                text="Social Ads across Facebook/Instagram Masthead"
                id="Social"
                name="Social"
                value="Social"
                v-model="form.digitalChannels"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <check-box
                title="Native"
                icon="bx-pointer"
                text="Native Ads on Premiun News Sites and Native Apps"
                id="Native"
                name="Native"
                value="Native"
                v-model="form.digitalChannels"
              />
            </div>                        
            <div class="col-12 col-md-6 col-lg-3">
              <check-box
                title="Search"
                icon="bx-search-alt"
                text="Google Search Ads targeted to Advertiser Profile"
                id="Search"
                name="Search"
                value="Search"
                v-model="form.digitalChannels"
              />
            </div>
        </div>
        <div v-if="submitted && $v.form.digitalChannels.$error" class="invalid-feedback">
          <span v-if="!$v.form.digitalChannels.required">This value is required.</span>
        </div>
      </b-form-group>
      <div class="row">
        <div class="col-6">
          <b-form-group label="Guaranteed Impressions" label-for="impressions">
            <p>Number of impressions this campaign will deliver</p>
            <b-form-input id="impressions" name="impressions" type="number" placeholder="Enter impressions amount" v-model="form.impressions" :class="{ 'is-invalid': submitted && $v.form.impressions.$error }" />
            <div v-if="submitted && $v.form.impressions.$error" class="invalid-feedback">
              <span v-if="!$v.form.impressions.required">This value is required.</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="Digital Cost ex GST" label-for="cost">
            <p>Total cost of the digital ads for this package</p>
            <b-form-input id="cost" name="cost" type="number" placeholder="Enter total package cost" v-model="form.digitalPrice" :class="{ 'is-invalid': submitted && $v.form.digitalPrice.$error }" />
            <div v-if="submitted && $v.form.digitalPrice.$error" class="invalid-feedback">
              <span v-if="!$v.form.digitalPrice.required">This value is required.</span>
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer="{ cancel }">
      <div>
        <b-button
          variant="primary"
          @click="() => submitDigitalModal(cancel)"
        >
          Save and Close
        </b-button>
      </div>
    </template>
  </b-modal>
</template>